interface LogoProps {
  /** Pixel height of the rendered SVG. Width is computed from the mark's
   *  natural bounding box (~23% of size). */
  size?: number;
  /** Override fill color. Defaults to the design system's --color-accent. */
  color?: string;
  /** Optional className for styling. */
  className?: string;
}

/**
 * Arcanum mark — two aligned bars on a transparent background.
 * Geometry matches the favicon / OG asset pack exactly:
 *   Bar:   7.0% w  ×  55.0% h of canvas
 *   Left:  x=38.5%, y=22.5%
 *   Right: x=54.5%, y=22.5%   (aligned, no stagger)
 *   Corners: square (radius 0)
 *
 * Render in a square 100×100 viewBox; the bars only occupy the central
 * column, so consumers can size by `size` (height) and the SVG will scale
 * isotropically.
 */
export function Logo({ size = 20, color, className }: LogoProps) {
  const fill = color ?? "var(--color-accent)";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect x="38.5" y="22.5" width="7.0" height="55.0" fill={fill} />
      <rect x="54.5" y="22.5" width="7.0" height="55.0" fill={fill} />
    </svg>
  );
}
